exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DotsPanel__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__DotsPanel__root {\n  position: absolute;\n  bottom: 20px;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  width: 100%;\n  padding-left: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.DS__DotsPanel__type_slider li:not(:last-child) {\n      margin-right: 8px;\n    }\n\n.DS__DotsPanel__type_dots li:not(:last-child) {\n      margin-right: 10px;\n    }\n", ""]);

// exports
exports.locals = {
	"root": "DS__DotsPanel__root",
	"type_slider": "DS__DotsPanel__type_slider",
	"type_dots": "DS__DotsPanel__type_dots"
};